import { Modal } from 'antd'

import styles from './confirmOversizedUpload.module.css'

const MAX_ATTACHMENT_SIZE_MB = 100

/**
 * Shows a dialog when one or more selected files exceed the size limit.
 * @param {{ fileNames?: string[], uploadingCount?: number, maxSizeMb?: number, productName?: string }} [options]
 */
export const confirmOversizedUpload = ({
    fileNames = [],
    uploadingCount,
    maxSizeMb = MAX_ATTACHMENT_SIZE_MB,
    productName = 'SoftwareCo',
} = {}) => {
    const names = (fileNames || []).filter(Boolean)
    if (names.length === 0) return

    // Title depends on how many files were being uploaded in this selection
    const totalUploading =
        typeof uploadingCount === 'number' && uploadingCount > 0
            ? uploadingCount
            : names.length
    const isMultiple = totalUploading > 1
    const title = isMultiple
        ? "Couldn't Upload Files"
        : "Couldn't Upload File"

    const rejectedIsMultiple = names.length > 1

    Modal.info({
        title,
        icon: null,
        centered: true,
        closable: true,
        maskClosable: true,
        width: 480,
        footer: null,
        rootClassName: styles.oversizedUploadModal,
        styles: {
            content: {
                padding: 0,
                borderRadius: 12,
                overflow: 'hidden',
            },
            header: {
                margin: 0,
                padding: '20px 24px 16px',
                borderBottom: '1px solid #e5e7eb',
            },
            body: {
                padding: '20px 24px 28px',
            },
        },
        content: (
            <div className={styles.content}>
                <p className={styles.message}>
                    {isMultiple
                        ? 'One or more files you selected is too large to upload.'
                        : 'The file you selected is too large to upload.'}{' '}
                    {productName} limits the size of attached files to{' '}
                    {maxSizeMb} MB each.
                </p>
                <p className={styles.fileList}>
                    The following {rejectedIsMultiple ? 'files' : 'file'} would
                    not upload correctly: {names.join(', ')}
                </p>
            </div>
        ),
    })
}

export { MAX_ATTACHMENT_SIZE_MB }
export default confirmOversizedUpload
